import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HomeComponent} from './components/home/home.component';
import {LoginComponent} from './components/login/login.component';
import {RegistroUsuarioComponent} from './components/registro-usuario/registro-usuario.component';
import {ActivateUserComponent} from './components/activate-user/activate-user.component';
import {RecuperarContrasenaComponent} from './components/recuperar-contrasena/recuperar-contrasena.component';
import {ChangePasswordRecoveryComponent} from './components/change-password-recovery/change-password-recovery.component';
import {MyProfileComponent} from './components/my-profile/my-profile.component';
import {MisUpaegsComponent} from './components/mis-upaegs/mis-upaegs.component';
import {VinculateUpaegComponent} from './components/vinculate-upaeg/vinculate-upaeg.component';
import {UpaegFisicaComponent} from './components/upaeg-fisica/upaeg-fisica.component';
import {UpaegMoralComponent} from './components/upaeg-moral/upaeg-moral.component';
import {UpaegGrupalComponent} from './components/upaeg-grupal/upaeg-grupal.component';
import {PresolicitudesComponent} from './components/presolicitudes/presolicitudes.component';
import {PresolicitudComponent} from './components/presolicitud/presolicitud.component';
import {DisponibilidadComponent} from './components/disponibilidad/disponibilidad.component';
import {UpaegsApoyoComponent} from './components/upaegs-apoyo/upaegs-apoyo.component';

import { ChangeEmailComponent } from './components/change-email/change-email.component';
import { SetNewEmailComponent } from './components/set-new-email/set-new-email.component';
import { MisTicketsComponent } from './components/mis-tickets/mis-tickets.component';
import { CrearTicketComponent } from './components/crear-ticket/crear-ticket.component';
import { TicketTalkComponent } from './components/ticket-talk/ticket-talk.component';
import { ValidarEmailPresolComponent } from './components/validar-email-presol/validar-email-presol.component';
import { VentanillaModule } from './modules/ventanilla/ventanilla.module';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
      path: 'home',
      component: HomeComponent
  },
  {
      path: 'login',
      component: LoginComponent
  },
  {
      path: 'nuevo/usuario',
      component: RegistroUsuarioComponent
  },
  {
    path: 'activation/:code',
    component: ActivateUserComponent
  },
  {
      path: 'recuperar/contrasena',
      component: RecuperarContrasenaComponent
  },
  {
      path: 'recuperacion/:code',
      component: ChangePasswordRecoveryComponent
  },
  {
      path: 'perfil',
      component: MyProfileComponent
  },
  {
      path: 'misupaegs',
      component: MisUpaegsComponent
  },
  {
      path: 'vinculate/:from',
      component: VinculateUpaegComponent
  },
  {
      path: 'create/fisica/:curp',
      component: UpaegFisicaComponent
  },
  {
      path: 'create/fisica',
      component: UpaegFisicaComponent
  },
  {
      path: 'upaeg/moral/:id/:from',
      component: UpaegMoralComponent
  },
  {
      path: 'upaeg/moral',
      component: UpaegMoralComponent
  },
  {
      path: 'upaeg/moral/:id',
      component: UpaegMoralComponent
  },
  {
      path: 'upaeg/grupal',
      component: UpaegGrupalComponent
  },
  {
      path: 'upaeg/grupal/:id',
      component: UpaegGrupalComponent
  },
  {
      path: 'upaeg/grupal/:id/:from',
      component: UpaegGrupalComponent
  },
  {
      path: 'presolicitudes/:id',
      component: PresolicitudesComponent
  },
  {
      path: 'presolicitud/:a/:b',
      component: PresolicitudComponent
  },
  {
      path: 'presolicitud/:a/:b/:c/:d/:e',
      component: PresolicitudComponent
  },
  {
      path: 'apoyos',
      component: DisponibilidadComponent
  },
  {
      path: 'apoyo/:ejercicio/:programa/:subprograma/:apoyo',
      component: UpaegsApoyoComponent
  },
  {
      path: 'change/email',
      component: ChangeEmailComponent
  },
  {
      path: 'cambio/email/:changeCode',
      component: SetNewEmailComponent
  },
  {
      path: 'mesadeayuda',
      component: MisTicketsComponent
  }
  ,
  {
      path: 'mesadeayuda/nuevo/ticket',
      component: CrearTicketComponent
  },
  {
      path: 'mesadeayuda/ticket/:id',
      component: TicketTalkComponent
  },
  {
    path: 'validate/email/presol/:code',
    component: ValidarEmailPresolComponent
  },
  {
    path: 'ventanilla',
    loadChildren: ()=> VentanillaModule
  }
  /*
  {
      path: 'presolicitud/:idUpaeg/:idPresol',
      component: PresolicitudComponent
  },
  {
      path: 'presolicitud/:idUpaeg/:ejercicio/:programa/:subprograma/:apoyo',
      component: PresolicitudComponent
  }
  ,
  {
      path: 'presolicitud/:idUpaeg',
      component: PresolicitudComponent
  }
  ,
  {
      path: 'apoyo/:ejercicio/:programa/:subprograma/:apoyo',
      component: UpaegsApoyoComponent
  }*/



];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
